export const TARIFF_LIMIT_ERROR_CODES = [
    'free_tariff_limit_exceeded',
    'trial_limit_exceeded',
    'tariff_teachers_limit_exceeded',
    'tariff_students_limit_exceeded',
    'homework_weekly_limit_exceeded',
];

export function isTariffLimitError(message) {
    return TARIFF_LIMIT_ERROR_CODES.includes(message);
}

export function showTariffLimitToast(message, { i18n, router, toasted }) {
    toasted.error(i18n.t(`errors.${message}`), {
        duration: 10000,
        className: 'tariff-limit-toast',
        action: {
            text: i18n.t('errors.view_tariffs'),
            class: 'tariff-limit-toast__action',
            onClick: (_event, toastObject) => {
                toastObject.goAway(0);
                router.push({ name: 'tariffs:list' });
            },
        },
    });
}
